<template>
  <div id="BrandHomepage" class="page-content">
    <div style="margin: -40px 0px 0px 0;">
    <el-row>
      <el-col :span="24" style="margin-bottom: 20px;" v-if="type.version == '1049'">
        <div style="font-size: 16px;color: #333333;display: flex;">
          <div class="iconDiv">
            .
          </div>
          待办事项
        </div>
      </el-col>
      <el-col :span="24" v-if="type.version == '1049'">
        <el-card class="box-card">
          <el-row class="elRow" style="display: flex;">
            <div class="approvalHover" @click="activitiesFor(7)">
              <el-col :span="21" class="ellipsisStyle">
                <el-image class="approvalHoverImage" :src='require("@/assets/img/cslogo.png")'></el-image>
                <span class="titleSpan">违规举报待初审</span>
              </el-col>
              <el-col :span="3">
                <span class="dataSpan">{{firstTrial}}</span>
              </el-col>
            </div>

            <div class="approvalHover" @click="activitiesFor(5)">
              <el-col :span="21" class="ellipsisStyle">
                <el-image class="approvalHoverImage" :src='require("@/assets/img/fclogo.png")'></el-image>
                <span class="titleSpan">授权违规举报待复查</span>
              </el-col>
              <el-col :span="3">
                <span class="dataSpan">{{reexamination}}</span>
              </el-col>
            </div>

            <div class="approvalHover" @click="activitiesFor(2)">
              <el-col :span="21">
                <el-image class="approvalHoverImage" :src='require("@/assets/img/violations.png")'></el-image>
                <span class="titleSpan">授权违规举报待处理</span>
              </el-col>
              <el-col :span="3">
                <span class="dataSpan">{{count}}</span>
              </el-col>
            </div>
          </el-row>
          <el-row class="elRow" style="display: flex;">
            <div class="approvalHover" @click="activitiesFor(6)">
              <el-col :span="21">
                <el-image class="approvalHoverImage" :src='require("@/assets/img/creditScores.png")'></el-image>
                <span class="titleSpan">信用积分待扣分处理</span>
              </el-col>
              <el-col :span="3">
                <span class="dataSpan">{{creditScoreNum}}</span>
              </el-col>
            </div>
            <div class="approvalHover" @click="activitiesFor(1)">
              <el-col :span="21">
                <el-image class="approvalHoverImage" :src='require("@/assets/img/approval.png")'></el-image>
                <span class="titleSpan">活动信息待审批</span>
              </el-col>
              <el-col :span="3">
                <span class="dataSpan">{{campaign_examine_apply}}</span>
              </el-col>
            </div>
            <div class="approvalHover" >

            </div>
          </el-row>
        </el-card>
      </el-col>

      <el-col :span="24" style="margin-top: 20px;">
        <div style="font-size: 16px;color: #333333;display: flex;">
          <div class="iconDiv">
            .
          </div>
          渠道管理服务数据概览
        </div>
      </el-col>
      <el-col :span="6" style="margin-top: 20px;padding-right: 16px;">
        <el-card class="box-card5">
          <div style="margin-left: 22px;float: left;">
            <el-image :src='require("@/assets/img/purple.png")'></el-image>
          </div>
          <div style="margin-left: 10px;float: left;margin-top: 28px;color: #666666;">
            渠道档案收录店铺
          </div>
          <el-row>
            <el-col :span="24">
              <div style="margin-left: 54px;font-size: 24px;font-weight: 500;color: #333333;">
                {{countAll}}
              </div>
            </el-col>
            <div style="margin-left: 57px;color: #666666;">
              <el-col :span="6" style="margin-top: 15px;">
                授权
              </el-col>
              <el-col :span="6" style="margin-top: 15px;">
                {{authorizecount}}%
              </el-col>
              <el-col :span="6" style="margin-top: 15px;">
                非授权
              </el-col>
              <el-col :span="6" style="margin-top: 15px;">
                {{unauthorizecount}}%
              </el-col>
            </div>
            <div style="margin-left: 57px;color: #666666;">
              <el-col :span="12" style="margin-top: 15px;" class="ellipsisStyle">
                最近30天收录店铺
              </el-col>
              <el-col :span="12" style="margin-top: 15px;">
                {{count30}}
              </el-col>
            </div>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="6" style="margin-top: 20px;padding-right: 16px;">
        <el-card class="box-card5">
          <div style="margin-left: 22px;float: left;">
            <el-image :src='require("@/assets/img/yellow.png")'></el-image>
          </div>
          <div style="margin-left: 10px;float: left;margin-top: 28px;color: #666666;">
            近7次检索违规商品链接
          </div>
          <el-row>
            <el-col :span="24">
              <div style="margin-left: 54px;font-size: 24px;font-weight: 500;color: #333333;">
                {{totalCount}}
              </div>
            </el-col>
            <div style="margin-left: 57px;color: #666666;">
              <el-col :span="12" style="margin-top: 52px;" class="ellipsisStyle">
                最近一次检索违规
              </el-col>
              <el-col :span="12" style="margin-top: 52px;">
                {{lastCount}}
              </el-col>
            </div>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="6" style="margin-top: 20px;padding-right: 16px;">
        <el-card class="box-card5">
          <div style="margin-left: 22px;float: left;">
            <el-image :src='require("@/assets/img/red.png")'></el-image>
          </div>
          <div style="margin-left: 10px;float: left;margin-top: 28px;color: #666666;">
            近30天通知整改商品链接
          </div>
          <el-row>
            <el-col :span="24">
              <div style="margin-left: 54px;font-size: 24px;font-weight: 500;color: #333333;">
                {{UrlCount}}
              </div>
            </el-col>
            <div style="margin-left: 57px;color: #666666;">
              <el-col :span="12" style="margin-top: 52px;" class="ellipsisStyle">
                复查整改合格率
              </el-col>
              <el-col :span="12" style="margin-top: 52px;">
                {{cas4}}%
              </el-col>
            </div>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="6" style="margin-top: 20px;">
        <el-card class="box-card5">
          <div style="margin-left: 22px;float: left;">
            <el-image :src='require("@/assets/img/blue.png")'></el-image>
          </div>
          <div style="margin-left: 10px;float: left;margin-top: 28px;color: #666666;">
            知产投诉商品链接
          </div>
          <el-row>
            <el-col :span="24">
              <div style="margin-left: 54px;font-size: 24px;font-weight: 500;color: #333333;">
                {{maincount}}
              </div>
            </el-col>
            <div style="margin-left: 57px;color: #666666;">
              <el-col :span="6" style="margin-top: 15px;">
                阿里
              </el-col>
              <el-col :span="6" style="margin-top: 15px;">
                {{tbcount}}
              </el-col>
              <el-col :span="6" style="margin-top: 15px;">
                京东
              </el-col>
              <el-col :span="6" style="margin-top: 15px;">
                {{jdcount}}
              </el-col>
              <el-col :span="6" style="margin-top: 15px;">
                苏宁
              </el-col>
              <el-col :span="6" style="margin-top: 15px;">
                {{sncount}}
              </el-col>
              <el-col :span="6" style="margin-top: 15px;">
                拼多多
              </el-col>
              <el-col :span="6" style="margin-top: 15px;">
                {{pddcount}}
              </el-col>
            </div>
          </el-row>
        </el-card>
      </el-col>

      <el-col :span="24" style="margin-top: 20px;" v-if="type.version == '1050' || type.version == '1049'">
        <div style="font-size: 16px;color: #333333;display: flex;">
          <div class="iconDiv">
            .
          </div>
          监控结果异常提醒
        </div>
      </el-col>
      <el-col :span="8" style="margin-top: 20px;" v-if="type.version == '1050' || type.version == '1049'">
        <el-card class="box-card6" style="margin-right: 16px;">
          <div style="margin: 20px 20px 0 20px;height: 40px;color: #666666;margin-top: 20px;">
            <div style="float: left;">
              监控产品异常
            </div>
            <div style="float: right;font-size: 24px;font-weight: 500;color: #333333;">
              {{productMonitor_num}}
            </div>
          </div>
          <el-image style="max-width: 100%;max-height: 100%;margin: 0 20px 0 20px;" :src='require("@/assets/img/fakeThree.png")'></el-image>
        </el-card>
      </el-col>
      <el-col :span="8" style="margin-top: 20px;" v-if="type.version == '1050' || type.version == '1049'">
        <el-card class="box-card6" style="margin-right: 16px;">
          <div style="margin: 20px 20px 0 20px;height: 40px;color: #666666;margin-top: 20px;">
            <div style="float: left;">
              监控店铺异常
            </div>
            <div style="float: right;font-size: 24px;font-weight: 500;color: #333333;">
              {{shopMonitor_num}}
            </div>
          </div>
          <el-image style="max-width: 100%;max-height: 100%;margin: 0 20px 0 20px;" :src='require("@/assets/img/fakeOne.png")'></el-image>
        </el-card>
      </el-col>
      <el-col :span="8" style="margin-top: 20px;" v-if="type.version == '1050' || type.version == '1049'">
        <el-card class="box-card6">
          <div style="margin: 20px 20px 0 20px;height: 40px;color: #666666;margin-top: 20px;">
            <div style="float: left;">
              监控链接异常
            </div>
            <div style="float: right;font-size: 24px;font-weight: 500;color: #333333;">
              {{danlian_yc_num}}
            </div>
          </div>
          <el-image style="max-width: 100%;max-height: 100%;margin: 0 20px 0 20px;" :src='require("@/assets/img/fakeTwo.png")'></el-image>
        </el-card>
      </el-col>

      <el-col :span="24" style="margin-bottom: 20px;margin-top: 20px;">
        <div style="font-size: 16px;color: #333333;display: flex;">
          <div class="iconDiv">
            .
          </div>
          品牌商品库信息概览
        </div>
      </el-col>
      <el-col :span="24" v-loading="pageMyChartloading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading">
        <el-card>
          <div class="bscroll" ref="bscroll" id="el-cardShadow">
            <div class="bscroll-container">
              <div style="display: flex;">
                <el-card style="cursor: pointer;width: 168px;height: 193px;margin: 24px 0 24px 24px;background-color: #FAFAFA;"  v-for="item in brandList" v-if="item.platform_name != '闲鱼'">
                  <div @click="brandClick(item.platform_code)">
                    <el-row>
                      <el-col :span="24" style="text-align: center;margin-top: 20px;">
                        <el-image style="width: 35px;height: 35px;" :src='require("@/assets/img/platform/pla_" + item.platform_code + ".png")'></el-image>
                      </el-col>
                      <el-col :span="24" style="text-align: center;">
                        <span>{{item.platform_name}}</span>
                      </el-col>
                      <el-col :span="14" style="text-align: left;margin-top: 20px;color: #666;padding-left: 16px;">
                        <span>店铺数</span>
                      </el-col>
                      <el-col :span="10" style="text-align: right;margin-top: 10px;padding-right: 16px;">
                        <span style="font-size: 24px;font-weight: 500;">{{item.shop_num}}</span>
                      </el-col>
                      <el-col :span="14" style="text-align: left;margin-top: 20px;color: #666;padding-left: 16px;">
                        <span>商品数</span>
                      </el-col>
                      <el-col :span="10" style="text-align: right;margin-top: 10px;padding-right: 16px;">
                        <span style="font-size: 24px;font-weight: 500;">{{item.item_num}}</span>
                      </el-col>
                    </el-row>
                  </div>
                </el-card>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="12" style="margin-bottom: 20px;margin-top: 20px;">
        <div style="font-size: 16px;color: #333333;display: flex;">
          <div class="iconDiv">
            .
          </div>
          经销商所在地区分布
        </div>
      </el-col>
      <el-col :span="12" style="margin-bottom: 20px;margin-top: 20px;">
        <div style="font-size: 16px;color: #333333;display: flex;">
          <div class="iconDiv">
            .
          </div>
          店铺所属平台占比
        </div>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card2" style="margin-right: 20px;position: relative;" id="cardmy"
          v-loading="pageMyChartloading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading">
          <div style="position: absolute;top: 119px;left: 46%;font-size: 14px;color: #999999;" v-show="totalTo2 == 0">
            <img src="@/assets/img/other/nodata.svg">
          </div>
          <span v-show="totalTo2 == 0" style="position: absolute;top: 216px;left: 46.5%;font-size: 14px;color: #999999;">暂无数据</span>
          <el-row>
            <el-col :span="23" style="font-size: 20px;cursor: pointer;color: #409EFF;text-align: right;margin-top: 20px;">
              <i class="el-icon-download" @click="jxsDownload"></i>
              <i class="el-icon-document" style="margin-left: 10px;" @click="dialogTableVisible = true"></i>
            </el-col>
          </el-row>
          <div style="position: absolute;top: 175px;left: 142px;width: 100px;text-align: center;font-size: 26px;color: #333333;" v-show="totalTo2 != 0">{{totalTo2}}</div>
          <div style="position: absolute;top: 208px;left: 157px;font-size: 14px;color: #999999;" v-show="totalTo2 != 0">经销商数量</div>
          <div id="pageMyChart" :style="{width: '642px', height: '302px'}"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card2" style="position: relative;"
          v-loading="myChart2loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading">
          <div style="position: absolute;top: 168px;left: 46%;font-size: 14px;color: #999999;" v-show="totalTo == 0">
            <img src="@/assets/img/other/nodata.svg">
          </div>
          <span v-show="totalTo == 0" style="position: absolute;top: 216px;left: 46.5%;font-size: 14px;color: #999999;">暂无数据</span>
          <div>
            <el-row>
              <el-col :span="13" style="font-size: 20px;cursor: pointer;color: #409EFF;text-align: left;">
                <el-radio-group v-model="radio1" size="mini" style="margin-top: 20px;margin-left: 30px;" @change="shopsGroupPing()">
                  <el-radio-button label="1">授权</el-radio-button>
                  <el-radio-button label="2">灰名单</el-radio-button>
                  <el-radio-button label="3">黑名单</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="10" style="font-size: 20px;cursor: pointer;color: #409EFF;text-align: right;margin-top: 20px;">
                <i class="el-icon-download" @click="shopDownload"></i>
                <i class="el-icon-document" @click="shopVisible = true" style="margin-left: 10px;"></i>
              </el-col>
            </el-row>
          </div>
          <div style="position: absolute;top: 169px;left: 142px;width: 100px;text-align: center;font-size: 26px;color: #333333;" v-show="totalTo != 0">{{totalTo}}</div>
          <div style="position: absolute;top: 203px;left: 157px;font-size: 14px;color: #999999;" v-show="totalTo != 0">店铺总数量</div>
          <div id="myChart2" :style="{width: '642px', height: '302px'}"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
  <!-- 二维码 -->
  <!-- <el-dialog :visible.sync="dialogVisible" width="409px">
    <div style="text-align: center;">
      <img :src="wechatUrl" style="width: 197px;height: 197px;">
      <div style="font-size: 18px;color: #333333;margin-top: -13px;">关注微信公众号，绑定微信</div>
      <div style="font-size: 14px;color: #999999;margin-top: 41px;">关注微信公众号，绑定微信后:</div>
      <div style="font-size: 14px;color: #999999;margin-top: 12px;">1、可在移动端中查看业务消息，处理业务事项。</div>
      <div style="font-size: 14px;color: #999999;text-align: left;margin-left: 33px;">2、登录时可以使用微信扫码登录。</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="iKnow" size="small">我知道了</el-button>
    </span>
  </el-dialog> -->
  <el-dialog :visible.sync="dialogVisible" width="360px">
    <div style="text-align: center;">
      <img :src="wechatUrl" style="width: 197px;height: 197px;" />
      <div style="font-size: 18px;color: #333333;margin-top: -13px;">关注微信公众号，绑定微信</div>
      <div style="font-size: 14px;color: #999999;margin-top: 41px;">关注微信公众号，绑定微信后:</div>
      <div style="font-size: 14px;color: #999999;margin-top: 12px;">1、可在移动端中查看业务消息，处理业务事项。</div>
      <div
        style="font-size: 14px;color: #999999;text-align: center;"
      >2、登录时可以使用微信扫码登录。</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="confire_btn" @click="iKnow" size="small">我知道了</el-button>
    </span>
  </el-dialog>
  <!-- 到期提醒 -->
  <div class="unbundlingPhoneStyle" v-if="unbundlingPhoneShow">
    <div style="width: 100%;">
       <div style="display: flex;">
         <i class="el-icon-warning" style="color:#faad14;font-size: 25px;"></i>
         <div style="font-size: 16px;line-height: 25px;">业务即将到期提醒</div>
       </div>
       <div style="font-size: 14px;margin-top: 5px;">
         <span style="font-size: 14px;">贵司的BRM业务有效期至 {{bmaincustomer_validtime}}日，系统使用期限仅剩 {{dateDifference}}天，过期后将不能使用系统，请及时联系我们业务人员续期。</span>
       </div>
    </div>
    <div style="width: 100%;text-align: right;margin-top: 10px;">
      <el-button type="primary" @click="iKnow2" size="small">我知道了</el-button>
    </div>
  </div>
  <!-- 经销商所在地区分布数据详情 -->
  <el-dialog title="经销商所在地区分布数据详情" :visible.sync="dialogTableVisible">
    <el-button @click="jxsDownload" :loading="jxsLoading">下载数据</el-button>
    <el-table :data="dealersData" style="margin-bottom: 60px;">
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column property="name" label="省区"></el-table-column>
      <el-table-column property="proportion" label="占比"></el-table-column>
      <el-table-column property="value" label="经销商数量"></el-table-column>
    </el-table>
  </el-dialog>
  <!-- 店铺所属平台占比数据详情 -->
  <el-dialog title="店铺所属平台占比" :visible.sync="shopVisible">
    <el-button @click="shopDownload" :loading="shopLoading">下载数据</el-button>
    <el-table :data="theStoreData" style="margin-bottom: 60px;">
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column property="dict_name" label="平台"></el-table-column>
      <el-table-column property="proportion" label="占比"></el-table-column>
      <el-table-column property="value" label="店铺数量"></el-table-column>
    </el-table>
  </el-dialog>
  <wxBindingComponent ref="childWxBinding"/>
  </div>
</template>

<script>
  import axios from "axios";
  import BScroll from 'better-scroll'
  import { mapState, mapGetters, mapActions } from 'vuex';
  import wxBindingComponent from "components/wxComponent/wxBindingComponent.vue";
  export default {
    data() {
      return {
        myChart2loading: false,
        pageMyChartloading: false,
        shopVisible: false,
        dialogTableVisible: false,
        jxsLoading: false,
        shopLoading: false,
        wechatUrl:'',
        type: {},
        UrlCount: 0,
        cas4: 0,
        maincount: 0,
        tbcount: 0,
        jdcount: 0,
        pddcount: 0,
        sncount: 0,
        authorizecount: 0,
        unauthorizecount: 0,
        countAll: 0,
        count30: 0,
        lastCount: 0,
        totalCount: 0,
        aBScroll: '',
        campaign_examine_apply: 0,
        danlian_yc_num: 0,
        shopMonitor_num: 0,
        productMonitor_num: 0,
        count: 0,
        radio1: 1,
        totalTo: 0,
        totalTo2: 0,
        brandList: [],
        time:Date.parse(new Date()),
        dialogVisible: false,
        unbundlingPhoneShow: false,
        bmaincustomer_validtime: '',
        dateDifference: '',
        // 待初审
        firstTrial: 0,
        // 待复查
        reexamination: 0,
        //<经销商所在地区分布>
        dealersData: [],
        dealersDataValue: [],
        dealersDataName: [],
        //<经销商所在地区分布>
        //<店铺所属平台占比>
        theStoreData: [],
        theStoreDataValue: [],
        theStoreDataName: [],
        creditScoreNum: 0,
        //<店铺所属平台占比>
        colorArray:{
          'AMAZON':"#B0E413", 'YJWD':"#30CFED", 'BBWG':"#8686FA", 'platform_OTHER':"#E057F5", 'PDD':"#F5576B", 'GM':"#f7b33d",
          'JD':"#47A0FD", 'TM':"#32B300", 'WECD':"#fa2626", 'TB':"#f8f400",  'SN':"#8300D7",'1688':"#7a7700", 'ALST':"#f59fbc",
          'CCJ':"#fff99d", 'MGJ':"#31b573", 'SMT':"#ED5E00", 'YLW':"#A435FF", 'WPH':"#9e8b75", 'JMYP':"#29C4FE", '1HD':"#F500C0"
        },

      }
    },
    filters: {
      formatDate: function (value) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
       return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      }
    },
    mounted() {

      //滑动
      this.type = JSON.parse(window.localStorage.userData);
      console.log(this.type)
      // console.log(window.localStorage)
      this.$nextTick(() => {
        let bscrollDom = this.$refs.bscroll;
        this.aBScroll = new BScroll(bscrollDom,{
          startX:0,
          click:true,
          scrollX:true,
          scrollY:false,
        })
      })
      this.myDate()
      this.findShopCount();
      this.lowPriceHomePageCMS();
      this.bmaincustomerIndex();
      this.homeWechatnotice();
      this.shopsGroupPing()
    },
    methods: {
      // 经销商所在地区分布下载
      jxsDownload() {
        this.jxsLoading = true
        fetch({
          url: "hcm/Index/downloadDealerDaQuBiTable",
          method: "get",
          noFormat: true,
          responseType: "blob",
          timeout: 60 * 1000 * 5
        }).then(res => {
          //下载
          let url = window.URL.createObjectURL(new Blob([res]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", "经销商所在地区分布.xlsx");
          document.body.appendChild(link);
          link.click();
          this.jxsLoading = false
        });
      },
      // 店铺所属平台占比下载
      shopDownload() {
        this.shopLoading = true
        let datas = {
          shoptype: this.radio1,
        };
        fetch({
          url: "hcm/Index/downloadshopsGroupPing",
          method: "get",
          params: datas,
          noFormat: true,
          responseType: "blob",
          timeout: 60 * 1000 * 5
        }).then(res => {
          //下载
          let url = window.URL.createObjectURL(new Blob([res]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", "店铺所属平台占比.xlsx");
          document.body.appendChild(link);
          link.click();
          this.shopLoading = false
        });
      },

      onBindWechat(openid) {
        this.$refs.childWxBinding.getbmcwx('c',this.userid)
      },
      homeWechatnotice() {
        fetch({
          url: "hcm/iprViolationRetrieveData/homeWechatnotice",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            if (res.data.count.cas1) {
              this.UrlCount = res.data.count.cas1
            } else {
              this.UrlCount = 0
            }
            if (res.data.count.cas4) {
              this.cas4 = res.data.count.cas4
            } else {
              this.cas4 = 0
            }
          }
        })
      },
      myDate() {
        //获取当前日期
        var myDate = new Date();
        var nowY = myDate.getFullYear();
        var nowM = myDate.getMonth()+1;
        var nowD = myDate.getDate();
        var enddate = nowY+"-"+(nowM<10 ? "0" + nowM : nowM)+"-"+(nowD<10 ? "0"+ nowD : nowD)
        //获取三十天前日期
        var lw = new Date(myDate - 1000 * 60 * 60 * 24 * 90);//最后一个数字30可改，30天的意思
        var lastY = lw.getFullYear();
        var lastM = lw.getMonth()+1;
        var lastD = lw.getDate();
        var startdate=lastY+"-"+(lastM<10 ? "0" + lastM : lastM)+"-"+(lastD<10 ? "0"+ lastD : lastD);//三十天之前日期
        this.getComplaintOverview(startdate,enddate);
        // this.getResultByToday(startdate,enddate);
        this.getSatetCount(startdate,enddate);
      },
      getComplaintOverview(startdate,enddate) {
        fetch({
          url: "hcm/HcmComplaintdata/getcomplaintdatacountindex",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            if (res.data.maincount) {
              this.maincount = res.data.maincount
            } else {
              this.maincount = 0
            }
            if (res.data.tbcount) {
              this.tbcount = res.data.tbcount
            } else {
              this.tbcount = 0
            }
            if (res.data.jdcount) {
              this.jdcount = res.data.jdcount
            } else {
              this.jdcount = 0
            }
            if (res.data.pddcount) {
              this.pddcount = res.data.pddcount
            } else {
              this.pddcount = 0
            }
            if (res.data.sncount) {
              this.sncount = res.data.sncount
            } else {
              this.sncount = 0
            }
          }
        })
      },
      findShopCount() {
        fetch({
          url: "hcm/hcmShop/findShopCount",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.countAll = res.data.count
            this.count30 = res.data.count30
            this.authorizecount = res.data.authorizecount
            this.unauthorizecount = res.data.unauthorizecount
          }
        })
      },
      lowPriceHomePageCMS() {
        fetch({
          url: "hcm/iprViolationRetrieveData/lowPriceHomePageCMS",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.lastCount = res.data.lastCount
            this.totalCount = res.data.totalCount
          }
        })
      },
      // 获取数据接口
      getSatetCount(startdate,enddate){
        let params={
          starttime: startdate,
          endtime: enddate,
        }
        fetch({
            url: "hcm/hcmReport/getCountByBmcIndex",
            method: "get",
            params:params,
        })
        .then(res =>{
          if(res.status=='10000'){
            for (var i = 0; i < res.data.length; i++) {
              if (res.data[i].lable == '授权违规举报待初审') {
                this.firstTrial = res.data[i].count
              }
              if (res.data[i].lable == '授权违规举报待复查') {
                this.reexamination = res.data[i].count
              }
              if (res.data[i].lable == '信用积分待扣分处理') {
                this.creditScoreNum = res.data[i].count
              }
              if (res.data[i].lable == '授权违规举报待处理') {
                this.count = res.data[i].count
              }
            }
          }
        });
      },
      // 知道按钮
      iKnow() {
        this.dialogVisible = false
        let info = true
        sessionStorage.setItem('iKnowkey', JSON.stringify(info));
      },
      iKnow2() {
        this.unbundlingPhoneShow = false
        let info = true
        sessionStorage.setItem('iKnowkey2', JSON.stringify(info));
      },
      // 跳转
      activitiesFor(e) {
        // if (e == 1) {
        //   this.$router.push({
        //     path: '/ActivityApproval/:id'
        //   })
        // } else if ( e == 2) {
        //   this.$router.push({
        //     path: '/CreditScoreDeal'
        //   })
        // } else if ( e == 3) {
        //   this.$router.push({
        //     path: '/ProductPandect'
        //   })
        // } else if ( e == 4) {
        //   this.$router.push({
        //     path: '/LinkMonitorLinkList'
        //   })
        // } else if ( e == 5) {
        //   this.$router.push({
        //     path: '/CreditScoreDeal'
        //   })
        // } else if ( e == 6) {
        //   this.$router.push({
        //     path: '/OutLineDeal'
        //   })
        // } else if ( e == 7) {
        //   this.$router.push({
        //     path: '/CreditCheck'
        //   })
        // }

      },
      brandClick(e) {
        if (e == 'TB' || e == 'TM') {
          e = 'TB'
        }
        this.$router.push({
          path: '/BrandMerchandise?platformCode=' + e
        })
      },
      brmJoin() {
        this.$router.push({
          path: '/brmHomepage'
        })
      },
      bmaincustomerIndex() {
        this.pageMyChartloading = true
        fetch({
          url: "hcm/Index/bmaincustomerIndex",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.pageMyChartloading = false
            this.dealersData = []
            this.dealersDataValue = []
            this.dealersDataName = []
            this.brandList = data.pluginitemList
            this.dealersData = data.daquData
            this.theStoreData = data.shopGroupData
            this.campaign_examine_apply = data.campaign_examine_apply
            this.danlian_yc_num = data.danlian_yc_num
            this.productMonitor_num = data.productMonitor_num
            this.shopMonitor_num = data.shopMonitor_num
            this.bmaincustomer_validtime = data.bmaincustomer_validtime
            this.dateDifference = data.dateDifference
            this.userid = data.userid
            console.log('距离到期时间' + data.dateDifference + '天')
            console.log(sessionStorage.getItem('iKnowkey2'))
            if (data.dateDifference < 30 && sessionStorage.getItem('iKnowkey2') && sessionStorage.getItem('iKnowkey2') != 'true') {
              this.unbundlingPhoneShow = true
            } else {
              this.unbundlingPhoneShow = false
            }
            if (data.binding) {
              this.dialogVisible = false
            } else {
              this.onBindWechat()
            }
            //经销商所在地区分布 echarts数据
            if (this.dealersData) {
              for (var i = 0; i < this.dealersData.length; i++) {
                if (this.dealersData[i].name) {
                  this.dealersDataValue.push({
                    value:this.dealersData[i].value,
                    name:this.dealersData[i].name
                  })
                  this.dealersDataName.push(this.dealersData[i].name)
                }
              }
              for (var i = 0, l = this.dealersDataValue.length; i < l; i++) {
                this.totalTo2 += this.dealersData[i].value;
              }
              this.drawLine(this.dealersDataValue);
            }
          } else {
            this.pageMyChartloading = false
          }
        })
      },
      shopsGroupPing() {
        this.myChart2loading = true
        let params={
          shoptype: this.radio1,
        }
        fetch({
          url: "hcm/Index/shopsGroupPing",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.myChart2loading = false
            this.totalTo = 0
            this.theStoreData = []
            this.theStoreDataValue = []
            this.theStoreDataName = []
            this.theStoreData = data
            //店铺所属平台占比 echarts数据
            if (this.theStoreData) {
              for (var i = 0; i < this.theStoreData.length; i++) {
                if (this.theStoreData[i].name) {
                  this.theStoreDataValue.push({
                    value:this.theStoreData[i].value,
                    name:this.theStoreData[i].dict_name
                  })

                  this.theStoreDataName.push(this.theStoreData[i].dict_name)
                }
              }
              for (var i = 0, l = this.theStoreDataValue.length; i < l; i++) {
                this.totalTo += this.theStoreData[i].value;
              }
              this.drawLine2(this.theStoreDataValue);
            }

          } else {
            this.myChart2loading = false
          }
        })

      },
      drawLine(dealersDataValue){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('pageMyChart'))
        // 绘制图表
        myChart.setOption({
          tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          // right:200,
          y: 'center',    //延Y轴居中
          x: 'right', //居右显示
          itemGap:30,
          itemWidth:8,
          padding:10,
          textStyle:{
            fontSize: 12
          },
          align:'left',
          data:this.dealersDataName,
          icon:"circle",
          formatter:function(name){
            var total = 0;
            var target;
            for (var i = 0, l = dealersDataValue.length; i < l; i++) {
              total += dealersDataValue[i].value;
              if (dealersDataValue[i].name == name) {
                target = dealersDataValue[i].value;
                }
              }
              var arr = [
                '{a|'+name+'  '+target+'}{b|'+'('+((target/total)*100).toFixed(2)+'%)}'
              ]
              return arr.join('\n')
            },
          textStyle:{
            rich:{
              a:{
                fontSize:14,
                align:'left',
                color:"#666666",
                padding:[0,0,0,10]
              },
              b:{
                fontSize:14,
                color:"#999999",
                align:'right',
              }
            }
          },
        },
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        color:['#30cfed','#8686fa','#e057f5','#f5576b','#f7b33d','#8300d7','#f59fbc','#fff99d','#29c4fe','#a435ff','#ed5e00','#cbb99d','#31b573','#a8d59d','#e1c81d','#5ca341','#7a7700'],
        series: [
          {
             name:'访问来源',
             type:'pie',
             radius: ['50%', '70%'],
             center: ['30%', '50%'],
             avoidLabelOverlap: false,
             label: {
               normal: {
                   show: false,
                   position: 'left'
               },
             },
             labelLine: {
                 normal: {
                     show: false
                 }
             },
             data: this.dealersDataValue,
             itemStyle: {
              emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
        });
      },
      drawLine2(theStoreDataValue){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart2'))
        // 绘制图表
        myChart.setOption({
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b}: {c} ({d}%)"
          },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          // right:200,
          y: 'center',    //延Y轴居中
          x: 'right', //居右显示
          itemGap:30,
          itemWidth:8,
          padding:10,
          textStyle:{
            fontSize: 12
          },
          align:'left',
          data:this.theStoreDataName,
          icon:"circle",
          formatter:function(name){
            var total = 0;
            var target;
            for (var i = 0, l = theStoreDataValue.length; i < l; i++) {
              total += theStoreDataValue[i].value;
              if (theStoreDataValue[i].name == name) {
                target = theStoreDataValue[i].value;
                }
              }
              var arr = [
                '{a|'+name+'  '+target+'}{b|'+'('+((target/total)*100).toFixed(2)+'%)}'
              ]
              return arr.join('\n')
            },
          textStyle:{
            rich:{
              a:{
                fontSize:14,
                align:'left',
                color:"#666666",
                padding:[0,0,0,10]
              },
              b:{
                fontSize:14,
                color:"#999999",
                align:'right',
              }
            }
          },
        },
        color:['#30cfed','#8686fa','#e057f5','#f5576b','#f7b33d','#8300d7','#f59fbc','#fff99d','#29c4fe','#a435ff','#ed5e00','#cbb99d','#31b573','#a8d59d','#e1c81d','#5ca341','#7a7700'],
        series: [
          {
             name:'访问来源',
             type:'pie',
             radius: ['50%', '70%'],
             center: ['30%', '50%'],
             avoidLabelOverlap: false,
             label: {
               normal: {
                 show: false,
                 position: 'left'
               },
             },
             labelLine: {
               normal: {
                 show: false
               },
               emphasis: {
                 show: false
               }
             },
             data: this.theStoreDataValue,
          }
        ]
        });
      },
    },
    components:{
      wxBindingComponent
    }
  }
</script>
<style scoped lang="scss">
  .ellipsisStyle {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .isonStyle {
    float: right;
    margin-top: 20px;
    margin-right: 30px;
    color: #409EFF;
    cursor: pointer;
    font-size: 20px;
    z-index: 9999999999;
  }
  .box-card {
    margin-right: 10px;
    padding-bottom: 24px;
  }
  .box-card2 {
    height: 350px;
  }
  .box-card3 {
    height: 240px;
  }
  .box-card5 {
    height: 188px;
  }
  .box-card6 {
    padding-bottom: 20px;
  }
  .approvalHover {
    padding: 20px;
    width: 50%;
    height: 50px;
  }
  .approvalHoverImage {
    margin-left: 15px;
    margin: auto;
    float: left;
  }
  .elRow {
    height: 50px;
    line-height: 50px;
    // margin-top: 24px;
    margin-bottom: 16px;
  }
  .dataSpan {
    text-align: right;
    color: #333333;
    font-size: 24px;
    font-weight: 500;
  }
  .titleSpan {
    color: #999999;
    font-size: 14px;
    float: left;
    padding-left: 24px;
  }
  .iconDiv {
    width: 5px;
    background-color: #333333;
    margin-right: 10px;
    height: 21px;
    margin-top: 4px;
  }
  .bscroll{
    width: 3000px;
    // height: 190px;
    overflow: hidden;
  }
  .bscroll-container{
    width: 3430px;
    height: 241px;
  }
  .unbundlingPhoneStyle {
    width: 350px;
    background-color: white;
    padding: 20px;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 8px;
    position: fixed;
    top: 60px;
    right: 10px;
  }
  div.approvalHover:hover {
    width: 50%;
    box-shadow: 0 2px 8px rgba(0,0,0,.15);
    height: 50px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
  }
</style>
<style lang="scss">
#BrandHomepage {
  .el-dialog__header {
    border-bottom: none;
  }
  #el-cardShadow {
    .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover {
      webkit-box-shadow: none;
      box-shadow: none;
    }
    .el-card, .el-message {
      border-radius: 0px;
      overflow: hidden;
    }
    .el-card {
      border: none;
    }
  }
  .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover {
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .el-card, .el-message {
    border-radius: 16px;
    overflow: hidden;
  }
  .el-card {
    border: none;
  }
  .el-card__body {
    padding: 0px;
  }
  .header_father {
    width: 100% !important;
    height: 70px !important;
  }
  .el-button--primary {
    color: #FFF;
    background-color: #bda571;
    border-color: #bda571;
  }
  .el-button--primary:hover {
    color: #FFF;
    background-color: #c0ae8a;
    border-color: #c0ae8a;
  }
  #borderTitle {
    .el-dialog__header {
        border-bottom: 1px solid #d9d9d9;
    }
    .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
    }
  }
}
</style>
